// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2rgHn","signatureBlock":"Footer_signatureBlock__12sIh","signature":"Footer_signature__3oWhh"};